import { Component } from '@angular/core';

@Component({
  selector: 'app-sellin-detail-modal',
  templateUrl: './sellin-detail-modal.component.html',
  styleUrls: ['./sellin-detail-modal.component.css']
})
export class SellinDetailModalComponent {

    isOpen:boolean = false;
    isLoading:boolean = false;
    details:any = {};

    openModal(){ this.isOpen = true;}
    closeModal(){ this.isOpen = false; this.details = {};}
    
    setSellInData(details:any){
      if(details){  
        this.details = details;
        this.isOpen = true;
        console.log(this.details);
      }else{
        this.isOpen = false;
      }
    }

}
